/**
 * Navigation Helper for Cross-Domain Support
 * 
 * When running on noblesyntax.com, links to /login, /app, /subscription
 * should redirect to dataquadapp.com
 * 
 * When running on dataquadapp.com, links work normally
 */

// Get the site mode from environment
const SITE_MODE = process.env.REACT_APP_SITE_MODE || 'dataquad';
const DATAQUAD_DOMAIN = 'https://dataquadapp.com';

/**
 * Get the correct URL for app-related paths
 * On Noble Syntax site: returns full DataQuad URL
 * On DataQuad site: returns local path
 */
export const getAppUrl = (path = '/login') => {
  if (SITE_MODE === 'noblesyntax') {
    return `${DATAQUAD_DOMAIN}${path}`;
  }
  return path;
};

/**
 * Get subscription URL with plan data
 * For Noble Syntax: redirects to DataQuad with query params (state can't cross domains)
 * For DataQuad: uses local navigation with state
 */
export const getSubscriptionUrl = (planType, billingType) => {
  if (SITE_MODE === 'noblesyntax') {
    return `${DATAQUAD_DOMAIN}/subscription?plan=${planType}&billing=${billingType}`;
  }
  return '/subscription';
};

/**
 * Navigate to subscription page
 * Use this instead of navigate() for subscription links
 */
export const navigateToSubscription = (navigate, planType, billingType) => {
  if (SITE_MODE === 'noblesyntax') {
    // Cross-domain: use query params
    window.location.href = `${DATAQUAD_DOMAIN}/subscription?plan=${planType}&billing=${billingType}`;
  } else {
    // Same domain: use React Router state
    navigate('/subscription', {
      state: {
        selectedPlan: planType,
        billingType: billingType
      }
    });
  }
};

/**
 * Navigate to login/app
 */
export const navigateToApp = (navigate, path = '/login') => {
  if (SITE_MODE === 'noblesyntax') {
    window.location.href = `${DATAQUAD_DOMAIN}${path}`;
  } else {
    navigate(path);
  }
};

/**
 * Check if we're on the Noble Syntax site
 */
export const isNobleSyntaxSite = () => SITE_MODE === 'noblesyntax';

/**
 * Check if we're on the DataQuad site
 */
export const isDataQuadSite = () => SITE_MODE === 'dataquad';

export default {
  getAppUrl,
  getSubscriptionUrl,
  navigateToSubscription,
  navigateToApp,
  isNobleSyntaxSite,
  isDataQuadSite,
  SITE_MODE,
  DATAQUAD_DOMAIN
};